<template>
  <div class="logo" :style="logoStyle" aria-label="RepoDepot (RD)">
    <span class="logo__shield" :style="{ color: colorsComputed.end }" aria-hidden="true">
      <svg viewBox="0 0 32 32" role="img" focusable="false">
        <path
          class="logo__shield-body"
          d="M16 2.7L26.4 7.1V15.2C26.4 21.7 22.1 27.5 16 29.6C9.9 27.5 5.6 21.7 5.6 15.2V7.1L16 2.7Z"
        />
        <path
          class="logo__shield-face"
          d="M16 5.4L23.3 8.5V15.3C23.3 20.3 20.4 24.4 16 26.4C11.6 24.4 8.7 20.3 8.7 15.3V8.5L16 5.4Z"
        />
        <path class="logo__shield-spine" d="M16 5.8V26.1" />
        <path class="logo__shield-node-line" d="M12.1 14.4L16 12.1L19.9 14.4M12.1 17.9L16 20.2L19.9 17.9M16 12.1V20.2" />
        <circle class="logo__shield-node" cx="16" cy="12.1" r="1.35" />
        <circle class="logo__shield-node" cx="12.1" cy="14.4" r="1.35" />
        <circle class="logo__shield-node" cx="19.9" cy="14.4" r="1.35" />
        <circle class="logo__shield-node" cx="12.1" cy="17.9" r="1.35" />
        <circle class="logo__shield-node" cx="19.9" cy="17.9" r="1.35" />
        <circle class="logo__shield-node" cx="16" cy="20.2" r="1.35" />
      </svg>
    </span>
    <span class="logo__brand" :style="{ color: colorsComputed.start }">RepoDepot</span>
    <span class="logo__suffix" :style="{ color: colorsComputed.end }">RD</span>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useColors } from 'vuestic-ui'

const { getColor } = useColors()

const props = withDefaults(
  defineProps<{
    height?: number
    start?: string
    end?: string
  }>(),
  {
    height: 18,
    start: 'primary',
    end: undefined,
  },
)

const colorsComputed = computed(() => {
  return {
    start: getColor(props.start),
    end: getColor(props.end || props.start),
  }
})

const logoStyle = computed(() => {
  const px = Math.max(14, props.height)
  return {
    fontSize: `${px}px`,
  }
})
</script>

<style scoped>
.logo {
  display: inline-flex;
  align-items: baseline;
  gap: 0.45rem;
  line-height: 1;
}

.logo__shield {
  display: inline-flex;
  width: 1em;
  height: 0.86em;
  transform: translateY(0.06em);
}

.logo__shield svg {
  width: 100%;
  height: 100%;
}

.logo__shield-body {
  fill: currentColor;
}

.logo__shield-face {
  fill: rgba(255, 255, 255, 0.16);
}

.logo__shield-spine {
  fill: none;
  stroke: rgba(0, 0, 0, 0.2);
  stroke-linecap: round;
  stroke-width: 1.1;
}

.logo__shield-node-line {
  fill: none;
  stroke: rgba(7, 18, 27, 0.48);
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.25;
}

.logo__shield-node {
  fill: rgba(255, 255, 255, 0.78);
}

.logo__brand {
  font-weight: 800;
  letter-spacing: 0.02em;
}

.logo__suffix {
  font-size: 0.52em;
  font-weight: 700;
  letter-spacing: 0.18em;
  margin-left: 0.12em;
}
</style>

